import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser'
import { DialogConfirmRequest, DialogConfirmResponse } from '../../../../../src/app/shared/model';

@Component({
  selector: 'app-dialogConfirm',
  templateUrl: 'dialogConfirm.component.html',
  styleUrls: ['./dialogConfirm.component.css']
})

export class DialogConfirmComponent implements OnInit {

  public title: string;
  public message: any;
  public buttonAcceptText: string;
  public buttonCancelText: string;
  public showButtonAcceptText: boolean = true;
  public showButtonCancelText: boolean = true;

  constructor(
    private dialogRef: MatDialogRef<DialogConfirmComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfirmRequest) {

  }

  ngOnInit() {
    this.title = this.data?.Title?.length > 0 ? this.data.Title : 'Confirmación de la Operación';
    this.message = this.sanitizer.bypassSecurityTrustHtml(this.data?.Message?.length > 0 ? this.data.Message : '¿Está seguro que desea continuar?');

    this.buttonAcceptText = this.data?.ButtonTextAccept?.length > 0 ? this.data.ButtonTextAccept : 'Aceptar';
    this.buttonCancelText = this.data?.ButtonTextCancel?.length > 0 ? this.data.ButtonTextCancel : 'Cancelar';

    this.showButtonAcceptText = this.data?.ShowButtonTextAccept ?? true;
    this.showButtonCancelText = this.data?.ShowButtonTextCancel ?? true;
  }

  onAccept() {
    this.dialogRef.close(new DialogConfirmResponse(true));
  }

  onDecline() {
    this.dialogRef.close(new DialogConfirmResponse(false));
  }
}
